import { motion } from "framer-motion";

const CORPORATE = [
  "Contratti inefficaci",
  "Clausole sbilanciate",
  "Governance poco chiara",
  "Conflitti tra soci",
  "Recupero crediti tardivo",
  "Responsabilità amministratori",
];

const REAL_ESTATE = [
  "Rischi urbanistici",
  "Contratti di appalto incompleti",
  "Gestione varianti",
  "Operazioni immobiliari poco strutturate",
  "Criticità nei preliminari",
  "Allocazione del rischio inefficiente",
];

function IssueList({ title, items, side, testId }) {
  return (
    <motion.div
      initial={{ opacity: 0, x: side === "left" ? -20 : 20 }}
      whileInView={{ opacity: 1, x: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.7 }}
      data-testid={testId}
    >
      <div className="overline mb-4">{title}</div>
      <ul>
        {items.map((it, i) => (
          <motion.li
            key={it}
            initial={{ opacity: 0, y: 12 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.4, delay: i * 0.06 }}
            className="flex items-baseline gap-6 py-5 border-b border-[#FAF9F6]/10 group"
          >
            <span className="font-display text-[#C5A880] text-sm tracking-widest min-w-[36px]">
              {String(i + 1).padStart(2, "0")}
            </span>
            <span className="text-lg lg:text-xl font-display tracking-tight group-hover:text-[#C5A880] transition-colors">
              {it}
            </span>
          </motion.li>
        ))}
      </ul>
    </motion.div>
  );
}

export default function Issues() {
  return (
    <section
      className="relative py-24 lg:py-32 border-t border-[#FAF9F6]/10"
      data-testid="issues-section"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="mb-16 max-w-3xl">
          <div className="overline mb-4">Criticità Più Frequenti</div>
          <h2 className="font-display text-4xl lg:text-6xl font-medium leading-[1.02] tracking-tight">
            Le criticità che
            <span className="block text-[#FAF9F6]/50 italic font-normal">
              prevediamo a monte.
            </span>
          </h2>
          <p className="mt-6 text-base text-[#FAF9F6]/65 max-w-xl leading-relaxed">
            Conoscere le aree di rischio ricorrenti consente di strutturare
            soluzioni preventive ed efficaci.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-16 lg:gap-24">
          <IssueList
            title="Corporate"
            items={CORPORATE}
            side="left"
            testId="issues-corporate"
          />
          <IssueList
            title="Real Estate"
            items={REAL_ESTATE}
            side="right"
            testId="issues-realestate"
          />
        </div>
      </div>
    </section>
  );
}
